import { useEffect, useState } from 'react'
import { SUPPORT_EMAIL } from '../config'

// Issue #57 — resolve the support contact at runtime from the anonymous endpoint
// (`/api/public/support-contact`), falling back to the build-time VITE_SUPPORT_EMAIL
// default. Used on the gate pages (AccessDenied / PendingActivation) which render
// before activation, so this uses a plain fetch (no auth token / react-query needed).
export function useSupportEmail(): string {
  const [email, setEmail] = useState<string>(SUPPORT_EMAIL)
  useEffect(() => {
    let alive = true
    fetch('/api/public/support-contact')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const runtime = typeof d?.email === 'string' ? d.email.trim() : ''
        if (alive && runtime) setEmail(runtime)
      })
      .catch(() => {
        /* keep build-env fallback */
      })
    return () => {
      alive = false
    }
  }, [])
  return email
}
